import m from "../../geodata/es2015/irelandHigh";
window.am4geodata_irelandHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/irelandHigh.js
// module id = null
// module chunks = 